import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class Warehouse {
  /* 获取所有仓库（不受权限控制） */
  static getAllWarehouseList() {
    const url = `/oa/api/warehouse/all/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取各仓库的项目列表(树状) */
  static getProjectByWarehouse() {
    const url = `/oa/api/warehouse/list/include/project`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取仓库库位列表 */
  static getWarehouseLocation() {
    const url = `/oa/api/warehouse/area/warehouse/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取仓库实占面积列表 */
  static getWarehouseRealArea() {
    const url = `/oa/api/use/area/import/list/warehouse`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取仓库人工成本列表 */
  static getWarehouseLaborCost(option) {
    let url = `/oa/api/employee/cost/import/list/by/warehouse?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Warehouse